/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { MdArrowBackIos, MdCheckCircle, MdOutlineCircle } from "react-icons/md";
import DOMPurify from 'isomorphic-dompurify';
import FileUploadTags from "./FileUploadTags";
// import EditorBox from "../chat/EditorBox";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { aesEncrypt, fileExtension, scrollToBottom, upload_obj } from "../../../Utils/Common";
import { setPopup } from "../../../redux/messageSlice";
import { useMutation } from "@apollo/client";
import { sendMsgMutation } from "../../../apollo/Mutations";
import { useUpload } from "../../../context/UploadContext";
import toast from "react-hot-toast";
import ListOfUsers from "../../popup/ListOfUsers";
import { useParams } from "react-router-dom";
import CustomEditor from "../chat/CustomEditor";
var all_files = [];

export default function FileUpload({ setFileUploadPopup, ...otherProps }) {
    const dispatch = useDispatch()
    const params = useParams()
    const { selected_ids, selected_uids, setSelected_uids, private_title } = useUpload()
    const { user, voice_file, private_msg, active_conversation, raw_message_text } = useSelector(state => state.message)
    // const messages = params.msg_id ? reply_msgs : msgs;
    const [voiceSetType, setVoiceSetType] = useState("");
    const [voiceSetTitle, setVoiceSetTitle] = useState("");
    const [isEditing, setIsEditing] = useState(null); // Track which file is being edited
    const [isReference, setIsReference] = useState(null);
    const [checkAllRefID, setCheckAllRefID] = useState(false);
    const [step, setStep] = useState(private_msg ? 'private_msg' : 'upload')
    const [referenceType, setReferenceType] = useState('');
    const [referenceID, setReferenceID] = useState('');

    const handleGoBack = () => {
        if (private_msg) {
            setStep('private_msg');
        } else {
            dispatch(setPopup({ key: 'upload_popup', value: false }))
        }
    };

    const [files, setFiles] = useState([]);

    const [completed_files, set_completed_files] = useState([])

    const uploadFiles = async (_f) => {
        // Convert FileList to Array
        const fileArray = Array.from(_f);

        const all_files = [...files]; // Ensure this is defined in your component state
        const bucket_name = user.email.replace(/[^a-zA-Z0-9]/g, '-');

        // Prepare file metadata
        fileArray.forEach((file, index) => {
            const sl = moment().format('x') + index;
            Object.assign(file, {
                sl,
                originalname: file.name,
                mimetype: file.type,
                fieldname: 'file_upload',
            });

            const sf = {
                sl,
                file_name: file.name,
                mimetype: file.type,
                file_size: file.size,
                status: 0,
                progress: 0, // progress as number
                local_url: URL.createObjectURL(file),
                referenceId: '',
                reference_type: '',
            };

            all_files.push(sf);
        });

        setFiles([...all_files]);

        // Upload files
        for (const file of fileArray) {
            const data = new FormData();
            data.append("bucket_name", bucket_name);
            data.append("sl", file.sl);
            data.append("file_upload", file);

            setFiles(prevFiles => prevFiles.map(f => f.sl === file.sl ? { ...f, progress: 0 } : f));

            try {
                const response = await upload_obj(data, {
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent && progressEvent.total) {
                            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            // console.log("🚀 ~ uploadFiles ~ percentCompleted:", percentCompleted)
                            setFiles(prevFiles => prevFiles.map(f => f.sl === file.sl ? { ...f, progress: percentCompleted } : f));
                        }
                    },
                });
                // On upload complete, set progress to 100
                setFiles(prevFiles => prevFiles.map(f => f.sl === file.sl ? { ...f, progress: 100 } : f));

                // Process successful upload
                const completedFile = all_files.find(f => f.sl === response.sl);
                if (completedFile) {
                    const newFile = {
                        ...response.file_info[0],
                        oldname: completedFile.file_name,
                        sl: completedFile.sl,
                        size: response.file_info[0].size,
                        referenceId: '',
                        reference_type: '',
                    };
                    set_completed_files(prev => [...prev, newFile])
                    setFiles(prevFiles => prevFiles.map(f => f.sl === file.sl ? { ...f, status: 1 } : f));
                }
            } catch (error) {
                console.error("Upload error:", error);
            }
        }

        if (voice_file?.length) {
            const firstFile = voice_file[0];
            setVoiceSetType(firstFile.voice_set_type || "");
            setVoiceSetTitle(firstFile.voice_set_title || "");
        } else {
            setVoiceSetType("");
            setVoiceSetTitle("");
        }
        // Do NOT revoke object URLs here; revoke only when file is removed or on unmount
    };

    useEffect(() => {
        // debugger
        if (voice_file) {
            uploadFiles(voice_file)
            dispatch(setPopup({ key: 'voice_file', value: null }))
        }
    }, [voice_file])

    const [edit_title, setEdit_title] = useState('')

    const handleEditToggle = (_f, index) => {
        setEdit_title(_f.file_name.split('.').slice(0, -1).join("."))
        setIsEditing(prev => prev === index ? null : index);
    };

    const handleEditReference = (index) => {
        setIsReference(isReference === index ? null : index);
    };

    const handleSave = (_f, index) => {
        if (edit_title?.trim() !== '') {
            let ext = _f.file_name.split('.').pop();
            setFiles(files.map(v => v.sl === _f.sl ? { ...v, file_name: edit_title?.trim() + '.' + ext } : v));
            set_completed_files(prev => prev.map(v => v.oldname === _f.file_name ? { ...v, voriginalName: edit_title?.trim() + '.' + ext } : v));
            setIsEditing(null);
            setEdit_title('');
        }
    };

    // Update referenceID or reference_type for a file in completed_files
    function updateFileReference(_f, field, value) {
        set_completed_files(prev => prev.map(file => {
            if (file.sl === _f.sl) {
                // For referenceID, also update the local files state for UI
                if (field === 'referenceID') {
                    setFiles(files => files.map(f => f.sl === _f.sl ? { ...f, referenceID: value } : f));
                }
                if (field === 'reference_type') {
                    setFiles(files => files.map(f => f.sl === _f.sl ? { ...f, reference_type: value } : f));
                    // If reference_type is cleared, also clear referenceID
                    if (value === '') {
                        setFiles(files => files.map(f => f.sl === _f.sl ? { ...f, referenceID: '' } : f));
                        return { ...file, reference_type: '', referenceID: '' };
                    }
                }
                return { ...file, [field]: value };
            }
            return file;
        }));
    }

    const handleCancel = () => {
        setEdit_title('');
        setIsEditing(null);
    };

    const handleClose = () => {
        if (private_msg && step === 'upload') {
            setStep('private_msg')
        } else {
            dispatch(setPopup({ key: 'upload_popup', value: false }))
            dispatch(setPopup({ key: 'private_msg', value: false }))
        }
    };

    function isBlank(str) {
        var newSting = str.replace(/(?:&nbsp;)/gm, '');
        return (!newSting || /^\s*$/.test(newSting));
    }

    const [send_msg_input] = useMutation(sendMsgMutation);

    const handleSendMsg = (data1, with_attachment = false) => {
        return new Promise(async (resolve, reject) => {
            try {
                // debugger;
                const content = raw_message_text.replace(/<\/?[^>]+(>|$)/g, '')
                let _isEmpty = isBlank(DOMPurify.sanitize(content.replace(/<[^>]*>?/gm, '')))
                var TrimText = content.replace(/[\r\n]/gm, '  </br>');
                var regex = /<\/br>$/;
                var TrimText1 = _isEmpty ? 'File(s) uploaded without any comment or message.' : TrimText.replace(regex, '');

                let imgfile = [];
                let audiofile = [];
                let videofile = [];
                let otherfile = [];
                let all_attachment = {};
                let allfiles = completed_files;

                for (let f of completed_files) {
                    // console.log(97, f);
                    var mime = f.mimetype;
                    if (mime.indexOf('image') !== -1)
                        imgfile.push(f.bucket + '/' + f.key);
                    else if (mime.indexOf('video') !== -1)
                        videofile.push(f.bucket + '/' + f.key);
                    else if (mime.indexOf('audio') !== -1)
                        audiofile.push(f.bucket + '/' + f.key);
                    else
                        otherfile.push(f.bucket + '/' + f.key);
                }
                all_attachment = {
                    imgfile: imgfile,
                    audiofile: audiofile,
                    videofile: videofile,
                    otherfile: otherfile,
                    allfiles: allfiles.map(v => ({
                        originalname: v.originalname,
                        mimetype: v.mimetype,
                        voriginalName: v.voriginalName,
                        size: v.size,
                        bucket: v.bucket,
                        key: v.key,
                        acl: v.acl,
                        referenceId: v.referenceID || '',
                        reference_type: v.reference_type || ''
                    })),
                }

                let input = {
                    conversation_id: active_conversation?.conversation_id,
                    company_id: user.company_id,
                    sender: user?.id,
                    msg_type: `${with_attachment ? 'media_attachment' : 'text'} ${otherProps.task ? 'discussion' : ''}`,
                    msg_body: aesEncrypt(TrimText1),
                    participants: active_conversation?.participants, //ThisRoom.room.participants,
                    is_reply_msg: params.msg_id ? 'yes' : 'no',
                    referenceId: referenceID,
                    reference_type: referenceType,
                    reply_for_msgid: params.msg_id ? params.msg_id : '',
                    flagged: otherProps.flagged ? true : false,
                    ...data1
                }
                // if (otherProps.is_reply_msg === 'yes') {
                //     input['reply_for_msgid'] = reply_main_msg?.msg_id
                // }
                if (otherProps.task) {
                    input['task_id'] = otherProps.task?._id
                }

                if (with_attachment) {
                    input = {
                        ...input,
                        attach_files: all_attachment,
                        all_attachment: allfiles.map(v => ({ tag_list: [], has_tag: "" }))
                    }
                }
                // console.log("🚀 ~ returnnewPromise ~ otherProps:", otherProps)
                if (otherProps.cost_id) {
                    input['file_group'] = 'cost'
                    input['cost_id'] = otherProps.cost_id
                }

                console.log("🚀 ~ returnnewPromise ~ input:", input)
                let send_msg_data = await send_msg_input({
                    variables: {
                        input: input
                    }
                });
                console.log(243, send_msg_data)
                dispatch(setPopup({ key: 'raw_message_text', value: '' }))

                if (private_msg) {
                    dispatch(setPopup({ key: 'upload_popup', value: false }))
                    dispatch(setPopup({ key: 'private_msg', value: false }))
                } else {
                    handleClose()
                }
                setTimeout(() => {
                    scrollToBottom('main_msg_scroll_div')
                }, 300);
                resolve(true)
            } catch (error) {
                console.log(error)
                reject(error)
            }
        })
    }

    const checkStatusUpload = (type) => {
        let data1 = {}
        let with_attachment = true;

        if (completed_files.length > 0) {
            with_attachment = true;
        } else {
            with_attachment = false;
        }
        switch (type) {
            case 'file_upload':
                data1 = {
                    is_secret: false,
                    tag_list: selected_ids,
                    ...(voiceSetType && { voice_set_type: voiceSetType }),
                    ...(voiceSetTitle && { msg_title: voiceSetTitle }),
                }
                break;
            case 'private_msg':
                data1 = {
                    is_secret: true,
                    tag_list: selected_ids,
                    secret_user: selected_uids,
                    msg_title: private_title
                }
                break;
            default:
                break;
        }
        handleSendMsg(data1, with_attachment);
    }


    const handleSend = () => {
        const allFilesUploaded = completed_files.length === files.length && completed_files.length !== 0;
        if (private_msg) {
            if (step === 'private_msg') {
                return checkStatusUpload('private_msg');
            }

            // Clean up the message text
            const content = raw_message_text.replace(/<\/?[^>]+(>|$)/g, '');
            const sanitizedContent = DOMPurify.sanitize(content.replace(/<[^>]*>?/gm, ''));
            const isEmptyMessage = isBlank(sanitizedContent);

            if (allFilesUploaded || (!completed_files.length && !files.length && !isEmptyMessage)) {
                checkStatusUpload('private_msg');
            } else {
                if (isEmptyMessage && !allFilesUploaded) {
                    toast.error('Message cannot be send without any text or file attachments');
                } else {
                    toast.error('Please wait for the file to upload');
                }
            }
        } else {
            if (allFilesUploaded) {
                checkStatusUpload('file_upload');
            } else {
                toast.error('Please wait for the file to upload');
            }
        }
    };


    useEffect(() => () => {
        // Cleanup: revoke all object URLs on unmount
        files.forEach(f => {
            if (f.local_url) {
                URL.revokeObjectURL(f.local_url);
            }
        });
        set_completed_files([])
        all_files = [];
        dispatch(setPopup({ key: 'raw_message_text', value: '' }))
        if (document.getElementById("_files")) {
            document.getElementById("_files").value = "";
        }
    }, [])

    const removeFile = (_f) => {
        setFiles(prev => prev.filter(v => v.sl !== _f.sl))
        all_files = all_files.filter(v => v.sl !== _f.sl)
        set_completed_files(prev => prev.filter(v => v.sl !== _f.sl))
        // Revoke object URL for removed file after UI update
        if (_f.local_url) {
            setTimeout(() => {
                URL.revokeObjectURL(_f.local_url);
            }, 100);
        }
    }


    const setRefId = (str) => {

        if (str === '') {
            // Allow clearing the input
            setReferenceID(str);
            return;
        }

        // Remove HTML tags
        str = str.replace(/<\/?[^>]+(>|$)/g, '');

        // Ensure the first character is not a special character
        while (/^[^\w]/.test(str)) {
            str = str.slice(1);
        }

        // Remove two consecutive special characters
        str = str.replace(/([^\w\s])\1+/g, '$1');

        // Trim the input
        str = str.trim();

        setReferenceID(str);
    };


    return (
        <div className="uploadPopup uploadPopupIndex bgSurfaceDark animate__animated animate__zoomIn animation_duration  ">
            {step === 'upload' ?
                <>
                    <header className="filterFileHeader !h-[50px]  ">
                        <div className="allfilterFileHeader items-center -mt-1" onClick={handleGoBack}>
                            <MdArrowBackIos className="allFileHeaderIcon thread_eHeaderIcon text-2xl -mt-1" />
                            <div className='mt-1'>
                                <span className="allFileHeaderText "> Upload file(s)</span>
                            </div>
                        </div>
                        <div className={`allfilterFileHeader`}>
                            <button onClick={() => setStep("tags")} className={`bg-teal-500 text-white rounded-full py-1 px-4 text-sm mr-4 ${files.length === 0 ? 'pointer-events-none opacity-[0.5]' : ''}`}>Continue</button>
                        </div>
                    </header>
                    <div className="uploadBody bgSurfaceDark">
                        <div className="uploadPointt border-2 mx-5 border-dashed border-teal-200 rounded-lg mt-5">
                            <input type="file" id="files" multiple hidden onChange={(e) => uploadFiles(e.target.files)} />
                            <label htmlFor="files" className="uploadLabel !text-teal-600 !pt-5 !pb-5 dark:!bg-teal-600 dark:!text-white">
                                Click here to upload file(s) from your device.
                            </label>
                        </div>
                        <div className="uploadedFileContainer bgSurfaceDark">
                            {files.length > 0 && <div className='py-3'>
                                <div className='w-full flex gap-1 items-center'>
                                    {
                                        checkAllRefID === true ?
                                            <MdCheckCircle onClick={() => setCheckAllRefID(!checkAllRefID)} className='text-teal-600  text-base cursor-pointer dark:text-white' />
                                            :
                                            <MdOutlineCircle onClick={() => setCheckAllRefID(!checkAllRefID)} className='text-teal-600  text-base cursor-pointer dark:text-white' />
                                    }
                                    <p className='text-teal-600  mt-[2px] text-sm cursor-pointer dark:text-white' onClick={() => setCheckAllRefID(!checkAllRefID)}>Use one reference ID for all files.</p>
                                </div>
                                {checkAllRefID &&
                                    <div className=' flex gap-2 w-full justify-between pt-2'>
                                        <div className='w-[45%]'>
                                            <select value={referenceType} onChange={(e) => { setReferenceType(e.target.value); !e.target.value && setRefId('') }} className='border placeholder-text-xs border-teal-600 rounded w-[100%] text-xs text-text-body dark:text-white  px-1 h-[28px] dark:bg-teal-600 dark:bg-teal-900  dark:text-white'>
                                                <option value="">Select reference type (optional)</option>
                                                <option value="SID">Student ID (SID)</option>
                                                <option value="EID">Employee ID (EID)</option>
                                                <option value="ID">No specific ref. (ID)</option>
                                            </select>
                                        </div>
                                        <div className='w-[55%] mr-1'>
                                            <input type="text" placeholder='Add a reference ID (optional)' value={referenceID} onChange={(e) => setRefId(e.target.value)}
                                                className='referenceTypeID border placeholder-text-xs text-xs border-teal-600 rounded w-[100%] text-teal-600  px-1 h-[28px] dark:bg-teal-900 '
                                                autoFocus={true}
                                                disabled={referenceType === ''}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>}
                            {files.map((_f, i) => (
                                <div className="uploaded_file dark:bg-teal-900 dark:border dark:border-teal-200 " id={"file_container_" + _f.sl} key={i}>
                                    {isEditing !== i && <span className="closeFileUpIcon" onClick={() => removeFile(_f)}></span>}
                                    <div className="flex items-center">
                                        <div className="uplogo">
                                            {_f.mimetype?.includes('image') && !_f.mimetype?.includes('svg') ?
                                                <img className={'object-cover h-[40px] w-[40px] rounded float-left'} fill={"true"} sizes='100%' src={_f.local_url} alt="Logo" title="Logo" />
                                                :
                                                <img className={'object-cover h-[40px] w-[40px] rounded float-left'} fill={"true"} sizes='100%' src={`/images/light_theme/${fileExtension(_f.file_name)}.svg`} title="Logo" alt="Logo" />
                                            }
                                        </div>
                                        <div className="upFileDetail dark:text-white">
                                            {isEditing === i ? (
                                                <input
                                                    type="text"
                                                    value={edit_title}
                                                    onChange={(e) => setEdit_title(e.target.value)}
                                                    onKeyUp={(e) => e.key === 'Enter' && handleSave(_f, i)}
                                                    autoFocus
                                                    className="w-[calc(100%-45px)] text-gray-600 border dark:border-teal-200 text-sm dark:bg-teal-900 rounded dark:text-white px-2"
                                                />
                                            ) : (
                                                <span className="upFileName text-sm text-text-body dark:text-white">{_f.file_name}</span>
                                            )}
                                            {isEditing !== i && <span className="fileEditActive" onClick={() => handleEditToggle(_f, i)}></span>}
                                            <div className="flex gap-1 items-center mt-[4px]">
                                                <p className="text-teal-600  text-xs cursor-pointer dark:text-white">{(_f.file_size / (1024 * 1024)).toFixed(2)} MB</p>
                                                {!checkAllRefID && <p onClick={() => handleEditReference(i)} className="text-teal-600 underline text-xs cursor-pointer dark:text-teal-400">{_f.referenceID ? <span> Reference ID: {_f.referenceID} </span> : 'Add a reference ID'}</p>}
                                            </div>
                                        </div>
                                    </div>

                                    {isEditing === i && (
                                        <span className="fileUpAction gap-1.5">
                                            <button className="bg-white border border-teal-200 text-teal-600 rounded px-1.5 !text-[10px] !pt-[1px] dark:text-white dark:bg-transparent" onClick={handleCancel}>Cancel</button>
                                            <button
                                                className="bg-teal-600 text-white px-1.5 rounded !text-[10px] !pt-[1px] dark:text-white"
                                                onClick={() => handleSave(_f, i)}
                                                disabled={edit_title?.trim() === _f.file_name.split('.').slice(0, -1).join(".") || edit_title?.trim() === ''}
                                            >Save</button>
                                        </span>
                                    )}

                                    {(!checkAllRefID && isReference === i) &&
                                        <div className=' flex gap-2 mt-2 pl-1.5 pr-1.5 mb-0 w-full'>
                                            <div className='w-[45%]'>
                                                <select value={_f.reference_type || ''} onChange={(e) => updateFileReference(_f, 'reference_type', e.target.value)} className='border placeholder-text-xs border-teal-600 rounded w-[100%] text-xs text-text-body dark:text-white  px-1 h-[28px] dark:bg-teal-600'>
                                                    <option value="">Select reference type (optional)</option>
                                                    <option value="SID">Student ID (SID)</option>
                                                    <option value="EID">Employee ID (EID)</option>
                                                    <option value="ID">No specific ref. (ID)</option>
                                                </select>
                                            </div>
                                            <div className='w-[55%]'>
                                                <input type="text"
                                                    placeholder='Add a reference ID (optional)'
                                                    value={_f.referenceID || ''}
                                                    onChange={(e) => updateFileReference(_f, 'referenceID', e.target.value)}
                                                    className='referenceTypeID border placeholder-text-xs text-xs border-teal-600 rounded w-[100%] text-teal-600  px-1 h-[28px]'
                                                    autoFocus={true}
                                                    disabled={_f.reference_type === ''}
                                                />
                                            </div>
                                        </div>
                                    }

                                    {_f.status === 0 &&
                                        <div className="progressContainer" id={`progressContainer_${_f.sl}`}>
                                            <div className="progressStatus dark:text-white">
                                                {_f.progress < 100 ? `${_f.progress}%` : ""}
                                            </div>
                                            <div className="progressBar">
                                                <span className="progressColor dark:bg-gray-600  text-[11px] text-[#fff] text-center leading-[14px]" style={{ width: `${_f.progress}%` }}>{_f.progress < 100 ? '' : "Processing..."}</span>
                                            </div>
                                        </div>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </>
                : step === 'private_msg' ? <ListOfUsers stepkey='private_msg' setUserPopup={setStep} form_data={selected_uids} setForm_data={setSelected_uids} />
                    : <FileUploadTags type={'file_upload'} setUploadStep={setStep} from={otherProps.from ? otherProps.from : ''} />
            }

            <CustomEditor type="fileUpload" handleSend={handleSend} />
        </div>
    );
}